import React from "react";
import { styled } from "@mui/material/styles";
import { Stack, Switch, FormGroup, Typography } from "@mui/material";
import PropTypes from "prop-types";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)"
    }
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.primary.green
      }
    }
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200
    })
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255,255,255,.35)"
        : "rgba(0,0,0,.25)",
    boxSizing: "border-box"
  }
}));

export const AntSwitchComponent = ({
  checked,
  defaultChecked,
  className,
  handleClick,
  style,
  labelLeft,
  labelRight
}) => {
  return (
    <FormGroup sx={{ marginLeft: "5px" }}>
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography className="poppins-font-family">{labelLeft}</Typography>
        <AntSwitch
          defaultChecked={defaultChecked}
          checked={checked}
          inputProps={{ "aria-label": "ant design" }}
          className={className}
          style={style}
          onChange={handleClick}
        />
        <Typography className="poppins-font-family">{labelRight}</Typography>
      </Stack>
    </FormGroup>
  );
};

AntSwitchComponent.prototype = {
  className: PropTypes.any,
  handleClick: PropTypes.func,
  style: PropTypes.any,
  checked: PropTypes.any,
  defaultChecked: PropTypes.any,
  labelLeft: PropTypes.string,
  labelRight: PropTypes.string
};
